/**
 * CODE FOR RATING
 */
jQuery(document).ready(function() {

  window.setTimeout(() => {
    const ajax_url = zw_settings.url;
    let dataArray = [];
    if (jQuery('.js-rmp-results-widget').length == 0) {
        jQuery('.rmp-widgets-container').each(function() {
            dataArray.push(jQuery(this).attr('data-post-id'));
            // dataArray[jQuery(this).attr('data-post-id')] = ;
        });
    } else {
        jQuery('.js-rmp-results-widget').each(function() {
            dataArray.push(jQuery(this).attr('data-post-id'));
            // dataArray[jQuery(this).attr('data-post-id')] = ;
        });
    }


    var data = {
        'action': 'zw_get_ajax_post_data',
        'secure': zw_settings.secure,
        'dataArray': dataArray
    };

    jQuery.post(ajax_url,
        data,
        function(response) {
            if (response != "0") {

                response = JSON.parse(response.data);
                for (let key in response) {
                    zwloadResults(response[key].rmp_vote_count, response[key].rmp_avg_rating, key);
                }
            }
        });

},0);

});

function zwloadResults(voteCount, avgRating, targetContainerID) {

    let container = jQuery('.js-rmp-results-widget[data-post-id="' + targetContainerID + '"]');


    let fullStars = Math.floor(avgRating);
    let extraHalfStar = false;
    let extraFullStar = false;
    let browserCompatbilityClass = '';
    let decimalValue = Math.round(avgRating % 1 * 10);

    if (decimalValue > 2 && decimalValue < 8) {
        extraHalfStar = true;
    }
    if (decimalValue >= 8) {
        extraFullStar = true;
    }

    if (decimalValue > 2 && decimalValue < 5) {
        browserCompatbilityClass = 'js-rmp-remove-half-star';
    }

    if (decimalValue >= 5 && decimalValue < 8) {
        browserCompatbilityClass = 'js-rmp-replace-half-star';
    }


    if (container.length >= 1) {
        jQuery(container[0]).find('.rmp-results-widget__avg-rating .js-rmp-avg-rating ').text(avgRating);
        jQuery(container[0]).find('.rmp-results-widget__vote-count .js-rmp-vote-count ').text(voteCount);
        jQuery(container[0]).parent('.post-rating-container').removeClass('d-none');


        jQuery(container[0]).find('.js-rmp-results-icon').each((index, item) => {
            if (index + 1 <= fullStars) {
                jQuery(item).addClass('rmp-icon--full-highlight');
            }
            if (extraHalfStar && (index + 1 == fullStars + 1)) {
                jQuery(item).addClass('rmp-icon--half-highlight');
                jQuery(item).addClass(browserCompatbilityClass);
            }

            if (extraFullStar && (index + 1 == fullStars + 1)) {
                jQuery(item).addClass('rmp-icon--full-highlight');
            }
        });

    }
}
